export default __webpack_public_path__ + "static/illustration-3-36e7bbe2b543c98cb15e7ff551bbad96.png";